//Login

export const LOGIN = "LOGIN";
export const CURRENT_USER = "CURRENT_USER"
